import * as React from 'react';
import { Button } from 'reactstrap';
import Icon from './Icons';

type Props = {
  onClick: () => void;
};

export default class ClearFiltersButton extends React.Component<Props> {
  render() {
    return (
      <div>
        <Button
          size="lg"
          outline
          color="primary"
          onClick={this.props.onClick}
          style={{ fontSize: '14px' }}
        >
          <Icon.XCircle className="mr-2 mt-n1" />
          Clear All
        </Button>
      </div>
    );
  }
}
